import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as C}from"../../icon-registry.js";const e=C("send",t`
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.6152 13.7569L4.0312 22.6003C3.65049 22.7819 3.28664 22.7469 2.93965 22.4952C2.59266 22.2435 2.4166 21.8734 2.41148 21.385L2.22989 4.06894C2.22477 3.58054 2.39302 3.20688 2.73466 2.94797C3.0763 2.68905 3.43933 2.64639 3.82376 2.81998L21.5893 11.2927C22.0701 11.5319 22.3135 11.9401 22.3196 12.5173C22.3256 13.0945 22.0908 13.5077 21.6152 13.7569ZM4.68596 19.363L18.2165 12.5603L4.54627 6.04288L4.59516 10.7049L11.5024 12.6307L4.63706 14.7009L4.68596 19.363Z"
                fill="#FCFCFC" />
        </svg>
    `),n=C("send_filled",t`
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.0312 22.6003C3.65049 22.7819 3.28664 22.7469 2.93965 22.4952C2.59266 22.2435 2.4166 21.8734 2.41148 21.385L2.34862 15.391L11.5024 12.6307L2.29275 10.063L2.22989 4.06894C2.22477 3.58054 2.39302 3.20688 2.73466 2.94797C3.0763 2.68905 3.43933 2.64639 3.82376 2.81998L21.5893 11.2927C22.0701 11.5319 22.3135 11.9401 22.3196 12.5173C22.3256 13.0945 22.0908 13.5077 21.6152 13.7569L4.0312 22.6003Z"
                fill="#FCFCFC" />
        </svg>
    `);export{e as Send,n as SendFilled};
